import Image from "next/legacy/image";

export const EmptySearchResult = () => {
  return (
    <div className="my-28 flex flex-1 flex-col items-center justify-center space-y-4">
      <Image
        alt="emptySearchResult"
        src="/images/search.png"
        layout="fixed"
        width={170}
        height={170}
        unoptimized
      />
      <div className="flex flex-col items-center space-y-2">
        <div className="text-lg font-normal text-gray-700">搜尋失敗</div>
        <div className="text-base font-light text-gray-500">
          試試更改條件重新搜尋
        </div>
      </div>
    </div>
  );
};
